// import * as React, from "react";
import React, {useEffect, useState, useRef} from "react";
import {Link} from "react-router-dom";

// Import Images
import darkLogo from "../../assets/images/dark-logo.svg";
import laptopImg from "../../assets/images/auth-laptop-image.png";


// Import Icons
import googleIcon from "../../assets/images/icons/google-icon.svg";
import microsoftIcon from "../../assets/images/icons/microsoft-icon.svg";
import eyeHideIcon from "../../assets/images/icons/eye-hide-icon.svg";
import eyeViewIcon from "../../assets/images/icons/eye-view-icon.svg";


function OtcTrade() {
    const [forgetPasswordStep, setForgetPasswordStep] = useState(1);
    const [otp, setOtp] = useState("");

    const [passwordsVisibility, setPasswordsVisibility] = useState({
        userPassword: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field) => {
        setPasswordsVisibility((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    // Otp Code
    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Allow only digits
        if (value.length <= 4) {
            setOtp(value);
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("Text").replace(/\D/g, ""); // Extract digits from pasted data
        if (pasteData.length === 4) {
            setOtp(pasteData);
        }
    };
    return (
        <div className='login-page'>
            <section className="sec-auth">
                <div className="auth-banner-wrapper">
                    <span className="top-notch"></span>
                    <div className="auth-banner-card">
                        <a href="#" className="logo">
                            <img src={darkLogo} alt="logo"/>
                        </a>
                        <div className="laptop-img">
                            <img src={laptopImg} alt="img"/>
                        </div>
                    </div>
                </div>
                <div className="user-auth-wrapper">
                    <div className="form-wrapper">
                        <h3 className="h-font">Forgot Password</h3>
                        <div className="form auth-form">
                            {(forgetPasswordStep === 1) &&
                                <div>
                                    <div className="form-group">
                                        <label htmlFor="user-email">Email ID</label>
                                        <input type="text" id="user-email" className="form-control" placeholder="Enter Email" />
                                    </div>
                                    <div className="form-group submit">
                                        <a href="#" className="btn-style full dark" onClick={() => setForgetPasswordStep(2)}>Continue</a>
                                    </div>
                                </div>
                            }
                            {(forgetPasswordStep === 2) &&
                                <div>
                                    <div className="form-group">
                                        <p className="f-12 w-600 otp-text">Enter OTP sent to mail id abc@ayx.com</p>
                                        <div className="row">
                                            <div className="col-6 align-self-center">
                                                <label htmlFor="email-otp">Enter OTP</label>
                                            </div>
                                            <div className="col-6 align-self-center">
                                                <div className="resend-otp">
                                                    <label htmlFor="resend-otp">Resend OTP</label>
                                                </div>
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            id="email-otp"
                                            className="form-control otp-input"
                                            placeholder="----"
                                            value={otp}
                                            onChange={handleOtpChange}
                                            onPaste={handleOtpPaste}
                                            maxLength="4" // Optional for better UX
                                        />
                                    </div>
                                    <div className="form-group submit">
                                        <a href="#" className="btn-style full dark" onClick={() => setForgetPasswordStep(3)}>Continue</a>
                                    </div>
                                </div>
                            }

                            {(forgetPasswordStep === 3) &&
                                <div>
                                    <div className="form-group">
                                        <label htmlFor="forgot-password">Enter New Password</label>
                                        <div className="key-input">
                                            <input
                                                type={passwordsVisibility.userPassword ? "text" : "password"}
                                                id="forgot-password"
                                                className="form-control"
                                                placeholder="Enter Password"
                                            />
                                            <img
                                                src={passwordsVisibility.userPassword ? eyeHideIcon : eyeViewIcon}
                                                className="icon"
                                                alt="toggle visibility"
                                                onClick={() => togglePasswordVisibility('userPassword')}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="forgot-repeat-password">Reenter New Password</label>
                                        <div className="key-input">
                                            <input
                                                type={passwordsVisibility.confirmPassword ? "text" : "password"}
                                                id="forgot-repeat-password"
                                                className="form-control"
                                                placeholder="Enter Password"
                                            />
                                            <img
                                                src={passwordsVisibility.confirmPassword ? eyeHideIcon : eyeViewIcon}
                                                className="icon"
                                                alt="toggle visibility"
                                                onClick={() => togglePasswordVisibility('confirmPassword')}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group submit">
                                        <Link to="/login" className="btn-style full dark">Continue</Link>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default OtcTrade
